import { Form, Input, message, Select } from "antd";
import React, { useState } from "react";

const Form2 = ({ companies = [], setShowDialog, onBack }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const handleSubmit = async (values) => {
    try {
      if (!/^[0-9]{10,11}$/.test(values.phone)) {
        messageApi.warning("Số điện thoại không hợp lệ.");
        return;
      }
      setLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_CRM_ENDPOINT_URL}/vi/api/v1.0/CustomerPortal/HiepHoiDoanhNghiep/up-sert/${process.env.REACT_APP_SECRETKEY}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },  
          body: JSON.stringify(values),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || "Lỗi kết nối server");
      }

      // ✅ Kiểm tra theo ReturnCode từ backend
      if (result && result.data.isOk) {
        form.resetFields();
        setShowDialog(true);
        setTimeout(() => {
          setShowDialog(false);
        }, 3000);
      } else {
        messageApi.warning(result.data.description || "Có lỗi xảy ra!");
      }
    } catch (error) {
      console.error("Lỗi:", error);
      messageApi.error("Không thể gửi dữ liệu. Vui lòng thử lại!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-box">
      {contextHolder}
      <h3 style={{ marginBottom: "10px" }}>Nhập thông tin liên hệ</h3>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        style={{ width: "100%" }}
        initialValues={{ type: 2 }}
      >
        <Form.Item
          name="fullName"
          rules={[
            { required: true, message: "Vui lòng nhập tên người liên hệ" },
          ]}
        >
          <Input
            placeholder="Tên người liên hệ"
            className="input-field"
            allowClear
          />
        </Form.Item>

        <Form.Item
          name="phone"
          rules={[{ required: true, message: "Vui lòng nhập số điện thoại" }]}
        >
          <Input
            placeholder="Số điện thoại"
            className="input-field"
            allowClear
          />
        </Form.Item>

        <Form.Item name="companyId">
          <Select
            placeholder="Chọn đơn vị"
            className="select-field"
            options={[{ value: 0, label: "Chọn đơn vị" }].concat(
              companies.map((c) => ({ value: c.id, label: c.name }))
            )}
            allowClear
            showSearch
            optionFilterProp="label"
            onClear={() => form.setFieldValue("companyId", null)}
            style={{ minHeight: 45, textAlign: "left" }}
          />
        </Form.Item>

        <Form.Item name="type" noStyle />

        <div style={{ textAlign: "center", marginTop: 10 }}>
          <button
            onClick={form.submit}
            className="submit-btn"
            disabled={loading} // chặn khi đang loading
          >
            {loading ? (
              <>
                <span className="loader"></span> Đang gửi...
              </>
            ) : (
              "Gửi thông tin"
            )}
          </button>
        </div>
      </Form>
    </div>
  );
};

export default Form2;
